import React, { useState } from 'react';
import './Faq.css';

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Pouvez-vous venir à mon événement privé ?",
      reponse: "Oui ! Nous intervenons pour les mariages, anniversaires, et événements d'entreprise. Contactez-nous via le formulaire pour un devis personnalisé."
    },
    {
      question: "Quels sont vos horaires ?",
      reponse: "Nos horaires varient selon les événements. Suivez-nous sur nos réseaux sociaux pour les prochaines dates, ou contactez-nous pour une réservation privée."
    },
    {
      question: "Proposez-vous des options végétariennes ou autres ?",
      reponse: "Oui, nos frites sont cuites dans de l'huile végétales et nous nous adaptons à vos demande sur ce sujet. N’hésitez pas à nous prévenir lors de votre réservation."
    },
    {
      question: "Combien de temps à l’avance faut-il réserver ?",
      reponse: "Pour les événements privés, nous recommandons de réserver au moins 2 semaines à l’avance. Pour les grands événements (mariages, festivals), 1 à 2 mois sont idéaux. contactez-nous directement pour en savoir plus !"
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="faq-section">
      <h2 className="section-title">Questions Fréquentes</h2>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div key={index} className={`faq-item ${openIndex === index ? 'open' : ''}`}>
            <div className="faq-question" onClick={() => toggleFAQ(index)}>
              <h3>{faq.question}</h3>
              <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
            </div>
            <div className="faq-reponse">
              <p>{faq.reponse}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Faq;
